import React from 'react';

function Loader({ caption = 'Loading...', containerHeight = '200px' }) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: containerHeight, flexDirection: 'column', gap: '8px' }}>
            <img
                src="/gifs/loader.gif"
                alt="Loading..."
                style={{
                    width: 'clamp(100px, 30%, 200px)',
                    height: 'auto',
                    objectFit: 'contain'
                }}
            />
            {caption && <p className="text-sm text-font-secondary">{caption}</p>}
        </div>
    );
}

export default Loader;